<template>
  <div class="location">
    <div class="map" v-if="computedCoordinates">
      <Map
        :coordinates="{
          latitude: computedCoordinates.latitude,
          longitude: computedCoordinates.longitude,
        }"
      />
    </div>

    <View direction="column" class="details">
      <View padding-bottom="lg">
        <PropertyDetailsCardInfoItem
          v-if="property?.location.state"
          label="State"
          icon="map-01"
          :value="property?.location.state"
          align="vertical"
        />

        <PropertyDetailsCardInfoItem
          v-if="property?.location.city"
          label="City"
          icon="building-06"
          :value="property?.location.city"
          align="vertical"
        />
      </View>

      <PropertyDetailsCardInfoItem
        v-if="property?.location.address"
        label="Address"
        icon="marker-pin-01"
        :value="property?.location.address"
        align="vertical"
      />
    </View>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { View } from '@tallo/design-system';

import { PropertyDto } from '../../model/property';
import Map from '../map/map.vue';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();
const computedCoordinates = computed(() => props.property!.location);
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.location {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--t-spacing-xl);

  @include mobile {
    grid-template-columns: 1fr;
  }

  .details {
    align-self: center;
  }
}
</style>
